import React, { createContext, useContext, useEffect } from "react";
import { Outlet } from "react-router-dom";

const RefundTrackerContext = createContext();

const RefundTrackerProvider = () => {
	useEffect(() => {}, []);

	return (
		<RefundTrackerContext.Provider value={{}}>
			<Outlet />
		</RefundTrackerContext.Provider>
	);
};

export const RefundTrackerState = () => {
	return useContext(RefundTrackerContext);
};

export default RefundTrackerProvider;
